import React from "react";

export default function FriendError({ tt, error }) {
    return (
        <div className='zt-p3 zt-event-buy__add-friends__friend__form__error' style={{textAlign: 'center'}}>{error}</div>
    );
}